/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  UpdateDiscoveryCall200,
  UpdateDiscoveryCallBody,
} from './platformapi.schemas';

import updateDiscoveryCallMutator from '../custom-axios-instance';

/**
 * API to accept or decline a pending introduction
 * @summary Update Discovery Call
 */
export const updateDiscoveryCall = (
  updateDiscoveryCallBody: UpdateDiscoveryCallBody,
  signal?: AbortSignal,
) => {
  return updateDiscoveryCallMutator<UpdateDiscoveryCall200>({
    url: `${import.meta.env['VITE_API_HOST']}/discovery/update_discovery_call`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateDiscoveryCallBody,
    signal,
  });
};

export const getUpdateDiscoveryCallMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDiscoveryCall>>,
    TError,
    { data: UpdateDiscoveryCallBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDiscoveryCall>>,
  TError,
  { data: UpdateDiscoveryCallBody },
  TContext
> => {
  const mutationKey = ['updateDiscoveryCall'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDiscoveryCall>>,
    { data: UpdateDiscoveryCallBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateDiscoveryCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDiscoveryCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDiscoveryCall>>
>;
export type UpdateDiscoveryCallMutationBody = UpdateDiscoveryCallBody;
export type UpdateDiscoveryCallMutationError = void | HTTPValidationError;

/**
 * @summary Update Discovery Call
 */
export const useUpdateDiscoveryCall = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDiscoveryCall>>,
      TError,
      { data: UpdateDiscoveryCallBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDiscoveryCall>>,
  TError,
  { data: UpdateDiscoveryCallBody },
  TContext
> => {
  const mutationOptions = getUpdateDiscoveryCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
